module.exports = __webpack_public_path__ + "static/home-9a690d1c1b65e26a3933c356f17533f7.jpg";